<template>
    <rkm-area
        title="Portal da transparência"
        type="fieldset"
    >
        <rkm-area
            title="Solicitações em espera"
            type="fieldset"
        >
            <template v-slot:trailing>
                <rkm-tooltip
                    placement="top"
                    :target="uniqueId('parametrizacao-regulacao-solicitacao-espera')"
                >
                    Solicitações em espera exibem itens ainda não finalizados.
                </rkm-tooltip>

                <rkm-icon
                    :id="uniqueId('parametrizacao-regulacao-solicitacao-espera')"
                    class="ml-1"
                    icon="info-circle"
                />
            </template>

            <rkm-area
                no-margin-top
                title="Colunas"
            >
                <template v-slot:trailing>
                    <rkm-tooltip
                        placement="top"
                        :target="uniqueId('parametrizacao-regulacao-solicitacao-espera-colunas')"
                    >
                        Defina quais informações poderão ser exibidas ao cidadão no Portal da Transparência, conforme a necessidade.
                    </rkm-tooltip>

                    <rkm-icon
                        :id="uniqueId('parametrizacao-regulacao-solicitacao-espera-colunas')"
                        class="ml-1"
                        icon="info-circle"
                    />
                </template>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-checkbox
                            v-for="coluna in data.model.portalTransparencia.abas.solicitacaoEspera.colunas"
                            :disabled="colunasObrigatorias.includes(coluna.id)"
                            :key="coluna.id"
                            inline
                            v-model="coluna.visivel"
                        >
                            {{ coluna.nome }}
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area title="Tipos de status">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-checkbox
                            v-for="statusTipo in data.model.portalTransparencia.abas.solicitacaoEspera.statusTipos"
                            :key="statusTipo.id"
                            inline
                            v-model="statusTipo.visivel"
                        >
                            {{ statusTipo.nome }}
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-area>

        <rkm-area
            title="Solicitações atendidas"
            type="fieldset"
        >
            <template v-slot:trailing>
                <rkm-tooltip
                    placement="top"
                    :target="uniqueId('parametrizacao-regulacao-solicitacao-atendida')"
                >
                    Solicitações atendidas exibem itens concluídos conforme os status configurados.
                </rkm-tooltip>

                <rkm-icon
                    :id="uniqueId('parametrizacao-regulacao-solicitacao-atendida')"
                    class="ml-1"
                    icon="info-circle"
                />
            </template>

            <rkm-area
                no-margin-top
                title="Colunas"
            >
                <template v-slot:trailing>
                    <rkm-tooltip
                        placement="top"
                        :target="uniqueId('parametrizacao-regulacao-solicitacao-atendida-colunas')"
                    >
                        Defina quais informações poderão ser exibidas ao cidadão no Portal da Transparência, conforme a necessidade.
                    </rkm-tooltip>

                    <rkm-icon
                        :id="uniqueId('parametrizacao-regulacao-solicitacao-atendida-colunas')"
                        class="ml-1"
                        icon="info-circle"
                    />
                </template>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-checkbox
                            v-for="coluna in data.model.portalTransparencia.abas.solicitacaoAtendida.colunas"
                            :disabled="colunasObrigatorias.includes(coluna.id)"
                            :key="coluna.id"
                            inline
                            v-model="coluna.visivel"
                        >
                            {{ coluna.nome }}
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area title="Tipos de status">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-checkbox
                            v-for="statusTipo in data.model.portalTransparencia.abas.solicitacaoAtendida.statusTipos"
                            :key="statusTipo.id"
                            inline
                            v-model="statusTipo.visivel"
                        >
                            {{ statusTipo.nome }}
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-area>

        <rkm-area
            v-if="showModoObterTempoMedioPrevistoAtendimento"
            title="Tempo médio previsto para atendimento"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.modosTempoMedio"
                        :validations="validations.modosTempoMedio"
                        label="Modo de obtenção do tempo médio previsto de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.portalTransparencia.modoTempoMedioId"
                        value-field="id"
                    />

                    <rkm-alert
                        v-if="data.model.portalTransparencia.modoTempoMedioId"
                        color="info"
                    >
                        <template v-if="data.model.portalTransparencia.modoTempoMedioId === enums.parametrizacaoDivulgacaoModoTempoMedio.AUTOMATICO">
                            O tempo médio previsto será calculado automaticamente com base no histórico entre a data da solicitação e a data do agendamento do procedimento.
                        </template>

                        <template v-else>
                            Para exibir o tempo médio previsto no modo manual, conclua também a configuração das funcionalidades relacionadas ao cadastro de especialidade e parametrização de exames.
                        </template>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-area>
</template>

<script>
// Enums.
import parametrizacaoDivulgacaoColuna from '@/enums/regulacao/parametrizacaoDivulgacaoColuna'
import parametrizacaoDivulgacaoModoTempoMedio from '@/enums/regulacao/parametrizacaoDivulgacaoModoTempoMedio'

export default {
    computed: {
        showModoObterTempoMedioPrevistoAtendimento() {
            return this.data.model.portalTransparencia.abas.solicitacaoEspera.colunas.some(coluna =>
                coluna.id === parametrizacaoDivulgacaoColuna.TEMPO_MEDIO_PREVISTO_PARA_ATENDIMENTO && coluna.visivel
            ) || this.data.model.portalTransparencia.abas.solicitacaoAtendida.colunas.some(coluna =>
                coluna.id === parametrizacaoDivulgacaoColuna.TEMPO_MEDIO_PREVISTO_PARA_ATENDIMENTO && coluna.visivel
            )
        },
        validations() {
            return {
                modosTempoMedio: { required: true },
            }
        },
        colunasObrigatorias() {
            return [
                this.enums.parametrizacaoDivulgacaoColuna.CLASSIFICACAO,
                this.enums.parametrizacaoDivulgacaoColuna.PROCEDIMENTO_CONSULTA,
                this.enums.parametrizacaoDivulgacaoColuna.DATA_DA_SOLICITACAO,
            ]
        }
    },
    data: () => ({
        enums: { parametrizacaoDivulgacaoColuna, parametrizacaoDivulgacaoModoTempoMedio }
    }),
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        showModoObterTempoMedioPrevistoAtendimento(show) {
            if (!show) {
                this.data.model.portalTransparencia.modoTempoMedioId = null
            }
        }
    }
}
</script>